import React, { Component } from "react";
import styled from "styled-components";
import "./About.css";


const Page = styled.section`

direction:rtl;

padding:100px 20px;

overflow:hidden;


background:
radial-gradient(circle at top right,#2563eb,transparent 35%),
radial-gradient(circle at bottom left,#7c3aed,transparent 35%),
linear-gradient(135deg,#071426,#102b50);


`;



const Header = styled.div`

text-align:center;

margin-bottom:60px;


h1{

font-size:55px;

font-weight:900;

color:white;

}


span{

background:linear-gradient(
90deg,
#60a5fa,
#c084fc
);

-webkit-background-clip:text;

-webkit-text-fill-color:transparent;

}



p{

color:#cbd5e1;

font-size:22px;

}



@media(max-width:600px){

h1{

font-size:38px;

}

}

`;

const AboutText = styled.div`

max-width:1000px;

margin:0 auto 70px;

text-align:center;

color:white;


h2{

font-size:42px;

font-weight:900;

margin-bottom:25px;

}


h2 span{

background:linear-gradient(
90deg,
#60a5fa,
#c084fc
);

-webkit-background-clip:text;

-webkit-text-fill-color:transparent;

}



p{

font-size:20px;

line-height:2;

color:#dbeafe;

margin-bottom:20px;

}



@media(max-width:600px){

h2{

font-size:32px;

}


p{

font-size:17px;

}


}

`;



const Features = styled.div`

max-width:1100px;

margin:0 auto 80px;


display:grid;

grid-template-columns:
repeat(auto-fit,minmax(220px,1fr));


gap:25px;



.feature{

background:
rgba(255,255,255,.10);


backdrop-filter:blur(20px);


border:1px solid rgba(255,255,255,.15);


border-radius:25px;


padding:30px;


text-align:center;


transition:.4s;


}


.feature:hover{

transform:translateY(-10px);

box-shadow:
0 25px 60px rgba(37,99,235,.4);

}



.icon{

font-size:45px;

margin-bottom:15px;

}



h3{

color:white;

font-size:22px;

}



p{

color:#cbd5e1;

font-size:16px;

}



`;


const MapContainer = styled.div`

max-width:1200px;

width:100%;

height:450px;

margin:0 auto;

position:relative;

overflow:hidden;

border-radius:35px;

border:1px solid rgba(255,255,255,.2);

box-shadow:
0 40px 100px rgba(0,0,0,.5);


& > div{

width:100% !important;

height:100% !important;

}


.gm-style{

width:100% !important;

height:100% !important;

}



@media(max-width:768px){

height:350px;

border-radius:25px;

}


@media(max-width:480px){

height:300px;

border-radius:20px;

}


`;





class About extends Component {


render(){


return(

<Page>



<Header>

<h1>

מי  <span>אנחנו</span>

</h1>


<p>

נשמח לעמוד לשירותכם ולענות על כל שאלה

</p>


</Header>


<AboutText>
  <h2>
  SITE <span>B2B</span>
</h2>

<h2>
בונים אתרים שמביאים <span>תוצאות</span>
</h2>


<p>
אנחנו מתמחים בבניית אתרי אינטרנט מתקדמים, מעוצבים ומותאמים לעולם העסקי החדש.
</p>
<p>
המטרה שלנו היא ליצור עבור כל עסק נוכחות דיגיטלית חזקה — אתר מהיר, מרשים ונוח לשימוש, שמייצג את העסק בצורה מקצועית ומייצר חוויית משתמש איכותית עבור הלקוחות.
</p>

<p>
אנו משלבים עיצוב מודרני, טכנולוגיות מתקדמות והתאמה מלאה למובייל, תוך חשיבה על ביצועים, קידום בגוגל והגדלת החשיפה של העסק ברשת.</p>

<p>
למה לבחור ב־SITE B2B?
</p>

<p>
 עיצוב בהתאמה אישית
כל אתר נבנה במיוחד עבור העסק שלך ולא מתבנית מוכנה.</p>

<p>
 מהירות וביצועים גבוהים
אתרים מהירים שמעניקים חוויית גלישה טובה יותר.</p>

<p>
 התאמה מלאה לכל מכשיר
עיצוב מושלם למחשב, טאבלט וסמארטפון.</p>

<p>
 חשיבה על קידום בגוגל
מבנה אתר נכון שמוכן לקידום אורגני.</p>


<p>
 ליווי אישי ושירות מקצועי
אנחנו מלווים אתכם לאורך כל הדרך — מהרעיון ועד האתר המוכן.</p>





<p>
SITEB2B — האתר שלך הוא הרושם הראשון של העסק שלך.
</p>

</AboutText>




<Features>


<div className="feature">

<div className="icon">
🚀
</div>

<h3>
עיצוב בהתאמה אישית
</h3>

<p>
אתר ייחודי שמתאים בדיוק לעסק שלך
</p>

</div>




<div className="feature">

<div className="icon">
⚡
</div>

<h3>
מהירות גבוהה
</h3>

<p>
אתרים מהירים עם חוויית גלישה מושלמת
</p>

</div>





<div className="feature">

<div className="icon">
📱
</div>

<h3>
מותאם לכל מסך
</h3>

<p>
מחשב, טאבלט וסמארטפון
</p>

</div>





<div className="feature">

<div className="icon">
🔍
</div>

<h3>
SEO וקידום
</h3>

<p>
מבנה נכון שמוכן לגוגל
</p>

</div>


</Features>



</Page>


);


}


}


export default About;